/** Figma 5074-14037 — vuesax/linear stat glyphs (message-question, timer, note). */
import surveyEntryStatQuestionsIcon from '../assets/survey-entry-stat-questions.svg'
import surveyEntryStatDurationIcon from '../assets/survey-entry-stat-duration.svg'
import surveyEntryStatInstrumentTypeIcon from '../assets/survey-entry-stat-instrument-type.svg'

export const surveyEntryStatAssets = {
  questionsIconUrl: surveyEntryStatQuestionsIcon,
  durationIconUrl: surveyEntryStatDurationIcon,
  instrumentTypeIconUrl: surveyEntryStatInstrumentTypeIcon,
} as const
